<section class="my-0">
  <div class="landing-page-wrapper">
    <header class="text-center mt-5">
      <h1>Welcome to NESS!</h1>
      <p>The Bureau of Alcohol, Tobacco, Firearms and Explosives (ATF’s) investigative tool for NIBIN and Crime Gun data.</p>
      <div class="landing-page-text" *removeIfNoPermission="canViewPBIReports">
        <div class="card">
          <div class="card-body">
            <p>
              <strong>Introducing the FIRST Dashboard in NESS - Click <a href="{{reportUrl}}" target="_blank" title="Open Dashboard" class="link">here for access</a>!</strong><br>
              This is for ATF Users Only and is the first of many dashboards the NESS Team will provide.<br>
              Please email <a href="mailto:NESS_Support@atf.gov?subject=Dashboard Feedback" title="Open a blank email to contact NESS support.">NESS_Support&#64;atf.gov</a> with "Dashboard Feedback"<br>
              as the subject line with ideas for additional dashboards.
            </p>
          </div>
        </div>
      </div>
    </header>
    <div class="row row-cols-1 row-cols-md-2 g-4 align-items-stretch">
      <div class="col">
        <div class="card h-100">
          <div class="card-body d-flex">
            <i class="icon icon-gun-cases me-4 text-primary" aria-hidden="true"></i>
            <div>
              <h2 class="card-title">Crime Gun Cases</h2>
              <p class="card-text">View a list of the most recently created or updated Crime Gun IDs for your area.</p>
            </div>
          </div>
          <div class="card-footer bg-body border-top-0 text-end">
            <a routerLink="/crime-guns" title="Navigate to a list of NESS crime guns." class="lp-btn btn btn-active">VIEW LIST</a>
          </div>
        </div>
      </div>
      <div class="col">
        <div class="card h-100">
          <div class="card-body d-flex">
            <i class="fas fa-md-5x fa-3x fa-users text-primary me-4" aria-hidden="true"></i>
            <div>
              <h2 class="card-title">People</h2>
              <p class="card-text">Find suspects, victims, witnesses, and other people tied to shootings and gun recoveries in your area.</p>
            </div>
          </div>
          <div class="card-footer bg-body border-top-0 text-end">
            <a routerLink="/people" title="Navigate to a list of NESS people." class="lp-btn btn btn-active">VIEW PEOPLE</a>
          </div>
        </div>
      </div>
      <div class="col">
        <div class="card h-100">
          <div class="card-body d-flex">
            <i class="icon icon-pistol me-4 text-primary" aria-hidden="true"></i>
            <div>
              <h2 class="card-title">Ballistic Evidence</h2>
              <p class="card-text">Search for ballistic evidence entered into NIBIN in your area.</p>
            </div>
          </div>
          <div class="card-footer bg-body border-top-0 text-end">
            <a routerLink="/search" title="Navigate to the NESS search page." class="lp-btn btn btn-active">SEARCH</a>
          </div>
        </div>
      </div>
      <div class="col">
        <div class="card h-100">
          <div class="card-body d-flex">
            <div class="me-4"><i class="icon icon-ness-seal" aria-hidden="true"></i></div>
            <div class="w-100">
              <h2 class="card-title">NESS Support & Training</h2>
              <p class="card-text">
                Need Help or Have an Idea to Share?
                <a href="mailto:NESS_Support@atf.gov" title="Open a blank email to contact NESS support." class="lp-btn d-md-block float-lg-end btn btn-active">CONTACT</a>
              </p>
              <p class="card-text">
                Want NESS Training?
                <a href="https://nesstraining.timetap.com/" target="_blank" title="Open NESS training request form." class="lp-btn d-md-block float-lg-end btn btn-active">REGISTER</a>
              </p>
            </div>
          </div>
        </div>
      </div>
    </div>
   </div>
</section>
